import type { ListStatusTone } from '@till-erp/platform/lists';
import { cn } from '../../lib/utils.ts';
import { pillToneClass } from './pill-tone.ts';
import { ToneMark } from './tone-mark.tsx';

/**
 * Status-Pille (DESIGN `components.status-pill`, „Status-Werte und Farbe“): immer mit Wort (EXPERIENCE §5.1). Bereit grün
 * mit Punkt, Prüfen bernstein mit Dreieck, Klärfall rot mit Quadrat (Story 7.32: auch ohne Farbe unterscheidbar); Wartet
 * grau mit kleiner Uhr; neutral grau nur mit Wort.
 */
export function StatusPill({ tone = 'neutral', children, className, testId }: { tone?: ListStatusTone; children: string; className?: string; testId?: string }) {
  return (
    <span
      data-testid={testId}
      data-tone={tone}
      className={cn(
        'type-meta inline-flex h-7 flex-none items-center gap-space-2 rounded-full px-space-3 whitespace-nowrap',
        // Farbe nur über den Ton-Vertrag (Story 26.17); „Wartet“ ist grau wie neutral.
        pillToneClass(tone === 'waiting' ? 'neutral' : tone),
        className,
      )}
    >
      <ToneMark tone={tone} />
      {children}
    </span>
  );
}
